"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ssl = void 0;
var qs = require('qs');
exports.ssl = function (axios) {
    return {
        //SSL 보안서버 신청
        postSsl: function (request) {
            var query = qs.stringify(request.params);
            return axios.post("/ssl?" + query, request.data);
        },
        //보안서버 신청가능한 상품 리스트 조회
        getSslProducts: function (params) {
            return axios.get('/ssl/products', { params: params });
        },
        //도메인별 SSL 보안서버 구매 내역 조회
        getSslPurchases: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/ssl/purchases?" + query);
        },
        //인증서 파일 다운로드
        getSslCertificateFiles: function (request) {
            request.responseType = 'blob';
            var query = qs.stringify(request.params);
            return axios.get("/ssl/certificate/files?" + query, request);
        },
        //SSL 보안서버 구매 내역 상세 조회
        getSslRequestSnoPurchasesDetail: function (request) {
            return axios.get("/ssl/" + request.pathParams.requestSno + "/purchases-detail");
        },
    };
};
